var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0L2 0C0.9 0 0 0.9 0 2L0 18C0 19.1 0.9 20 2 20L14 20C15.1 20 16 19.1 16 18L16 6L10 0ZM14 18L2 18L2 2L9 2L9 7H14L14 18ZM5 11L5 17H3L3 11H5ZM11 13V17L13 17V13H11ZM7 9L7 17H9V9H7Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEore);
export default __webpack_public_path__ + "static/media/eore.1dbe22b8d5b7e5df08bba425327717b7.svg";
export { ForwardRef as ReactComponent };